import loginFetch from "./apis/loginFetch";
import chatFetch from "./apis/chatFetch";

export default {
  ...loginFetch,
  ...chatFetch,
}